<template>
  <div class="home">
    <NavBar></NavBar>
    <img
      class="animate__animated animate__shakeX animate__infinite animate__slow"
      alt="Vue logo"
      src="../assets/car.png"
    />
    <h2>Brandiie Drive System</h2>
    <HelloWorld msg="Welcome to Your Vue.js App" />
    <UserCheck></UserCheck>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import NavBar from "@/components/NavBar.vue";
import UserCheck from "@/components/CompUserCheck.vue";

export default {
  name: "Home",
  components: {
    HelloWorld,
    NavBar,
    UserCheck
  }
};
</script>
<style>
@import "../assets/animate.min.css";
</style>
